import { Box, styled } from '@mui/material'

export const MainContent = styled(Box)(() => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'row',
  flexGrow: 1,
  height: 0,
}))

export const TableContent = styled(Box)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexGrow: 1,
  flexDirection: 'column',
  gap: theme.spacing(1),
  overflow: 'hidden',
}))

export const SidePart = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
  width: 'clamp(400px, 32%, 480px)',
}))
